import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import XeroService from "services/xero.service";

export const XeroUpdateKeyApi = createAsyncThunk("xero/updatekey", async (formValues, thunkAPI) => {
  try {
    const response = await XeroService.updateXeroKey(formValues);
    return response.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
    return thunkAPI.rejectWithValue(error.message);
  }
});

const initialState = {
  isOpenedXeroForm: "",
  isLoading: false,
  error: null,
};

const xeroSlice = createSlice({
  name: "xero",
  initialState,
  reducers: {
    OpenXeroForm: (state, action) => {
      state.isOpenedXeroForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(XeroUpdateKeyApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(XeroUpdateKeyApi.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(XeroUpdateKeyApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { OpenXeroForm } = xeroSlice.actions;
export default xeroSlice.reducer; 